import {createSelector} from 'reselect'
import {
    canAccessAllManagementScope,
    canAccessAllTeamScope,
    hasEditHierarchyRight,
    hasGenerateMoneyReportsRight,
    hasManagePtoAndSickDays,
    hasManageSystemSettingsRight,
    hasManageUsersRight,
    hasSomeTeamAssignment,
    hasSubmitOtherUsersTTRight
} from '../util/accessRightsUtils'
import {arrayToSet} from '../atUtils'
import {isBTYEnabled, isURAEnabled} from '../features/selectors'

//First created user in the context
const FIRST_ADMIN_ID = 1

export const getLoggedInUser = state => state.loggedInUser

export const getLoggedInUserId = state => getLoggedInUser(state).id

export const isFirstAdmin = createSelector(
    getLoggedInUserId,
    userId => userId === FIRST_ADMIN_ID
)

export const canEditHierarchy = createSelector(
    getLoggedInUser,
    user => hasEditHierarchyRight(user)
)

export const canManageAccountsAndPermissions = createSelector(
    getLoggedInUser,
    user => hasManageUsersRight(user)
)

export const canGenerateMoneyReports = createSelector(
    getLoggedInUser,
    user => hasGenerateMoneyReportsRight(user)
)

export const canSubmitOtherUsersTT = createSelector(
    getLoggedInUser,
    user => hasSubmitOtherUsersTTRight(user)
)

export const canManagePtoAndSickDays = createSelector(
    getLoggedInUser,
    user => hasManagePtoAndSickDays(user)
)

export const hasAccessAllManagementScope = createSelector(
    getLoggedInUser,
    user => canAccessAllManagementScope(user)
)

export const canAccessSomeTeamAssignment = createSelector(
    getLoggedInUser,
    user => hasSomeTeamAssignment(user)
)

export const canManageAllTeamScope = createSelector(
    getLoggedInUser,
    user => canAccessAllTeamScope(user)
)

export const hasManageScopeRights = createSelector(
    canGenerateMoneyReports,
    canEditHierarchy,
    canManageAccountsAndPermissions,
    canSubmitOtherUsersTT,
    isURAEnabled,
    isBTYEnabled,
    (canGenerateMoneyReports, canEditHierarchy, canManageAccountsAndPermissions, canSubmitOtherUsersTT, isURAEnabled, isBTYEnabled) =>
        canGenerateMoneyReports && (isURAEnabled || isBTYEnabled) || canEditHierarchy || canManageAccountsAndPermissions || canSubmitOtherUsersTT
)

export const getAccessRights = createSelector(
    getLoggedInUser,
    user => arrayToSet(user.accessRights)
)

export const hasPto = createSelector(
    getLoggedInUser,
    (user) => user.pto
)

export const hasSick = createSelector(
    getLoggedInUser,
    (user) => user.sick
)

export const canManageSystemSettings = createSelector(
    getLoggedInUser,
    user => hasManageSystemSettingsRight(user)
)

export const canSwitchToQBI = createSelector(
    canGenerateMoneyReports,
    hasAccessAllManagementScope,
    canManageAllTeamScope,
    (canGenerateMoneyReports, hasAccessAllManagementScope, canManageAllTeamScope) => {
        return canGenerateMoneyReports && hasAccessAllManagementScope && canManageAllTeamScope
    }
)

export const hasEmail = createSelector(
    getLoggedInUser,
    user => user.hasEmail
)

export const getEmail = createSelector(
    getLoggedInUser,
    user => user.email
)

export const getFirstName = createSelector(
    getLoggedInUser,
    user => user.firstName
)


// WEBPACK FOOTER //
// ./web/js/loggedInUser/selectors.js